import { updater } from "../../utils/updater.js";
import apiRequest from "../../utils/ApiRequest/apiRequest.js";
import getDictionaryType from "../../utils/cookieValueTransform.js";

/**
 * Marketing API factory.
 *
 */
export function marketingFactory({ state, setState }) {
  // shorthand for setState(produce(draft => {...}))
  const updateState = updater(setState);

  const getMarketingData = () => state.data;

  const setMarketingData = (res) => {
    updateState((draft) => {
      draft.data = res;
    });
  };

  const setNumNewNotifications = (res) => {
    updateState((draft) => {
      draft.newNotifications = res;
    });
  };

  const fetchMarketing = async ({
    languageCulture,
    cookie,
    mobileCondition,
    currentPage,
    mailId,
    cookieSetter,
  }) => {
    //todo: uncomment and add marketing logic
    //getMarketingType()
    const response =
      !getWasShown() &&
      (await apiRequest(
        "Contents",
        "ReactGetMarketingPopup",
        {
          CurrentRealCulture: languageCulture, //"en-us"
          IsMobile: mobileCondition,
          CurrentPage: currentPage, // "gallery"
          MailEncryptedId: mailId || null,
          UploadOrSaveCodeUsageEmail: null,
          ExistsCookiesDictionary: getDictionaryType(cookie),
          RequestedMarketingPopups: null, // ["SubscriptionAboutToExpire"]
        },
        "POST"
      ));
    if (response.status === "success" && response.data) {
      //need to add cookie worker
      cookieSetter(
        "marketingPopup",
        cookie
          ? "," + response.data.MarketingPopupName
          : response.data.MarketingPopupName
      );
      setMarketingData(response.data);
    }
  };
  const getNumNewNotifications = () => state.newNotifications;

  const fetchCountNotifications = async () => {
    const response = await apiRequest("Notifications", "CountNewNotifications");
    if (response.status === "success") {
      if (response.data) {
        setNumNewNotifications(response.data);
      } else {
        setNumNewNotifications(0);
      }
    }
  };

  const setWasShown = (bool) => {
    updateState((draft) => {
      draft.wasShown = bool;
    });
  };

  const getWasShown = () => state.wasShown;

  return {
    setWasShown,
    getWasShown,
    setMarketingData,
    getMarketingData,
    fetchMarketing,
    setNumNewNotifications,
    getNumNewNotifications,
    fetchCountNotifications,
  };
}

export default marketingFactory;
